import axios from 'axios';
import bearerTokenHeader from 'components/api-authorization/bearerToken';

export interface IEppMaterial {
  eppMaterialID: number;
  name: string;
}

export const getEppMaterials = async () => {
  const config = await bearerTokenHeader();
  const response = await axios.get('api/EppMaterial', config);
  return response.data;
};
